import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import React from 'react'

import SettingsCard from '../../../components/Settings/SettingsCard'
import SettingsLayout from '../../../components/Settings/SettingsLayout'
import { ROUTES } from '../../../constants/routes'
import CharityRegisterForm from './form'
import UserCharitiesList from '../userCharitiesList'

export default function CharityRegisterPage() {
  const { t } = useTranslation()
  const location = useLocation()
  const charity = location.state?.charity

  if (!charity?.id) {
    return <Navigate to={ROUTES.CHARITIES} replace />
  }

  const breadcrumbs = [
    { label: t('navigation_banner.home'), to: '/' },
    { label: t('charities.myCharities.title'), to: ROUTES.CHARITIES },
    { label: t('charities.register.title') },
  ]

  return (
    <SettingsLayout
      title={t('charities.register.title')}
      breadcrumbs={breadcrumbs}
    >
      <SettingsCard
        icon="hands-heart"
        title={t('charities.register.title')}
        description={t('charities.register.message')}
      >
        <CharityRegisterForm charity={charity} />
      </SettingsCard>
      <SettingsCard icon="hands-heart" title={t('charities.myCharities.title')}>
        <UserCharitiesList />
      </SettingsCard>
    </SettingsLayout>
  )
}
